import { render } from "./Form.vue?vue&type=template&id=46841fb6&scoped=true&ts=true"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"

import "./Form.vue?vue&type=style&index=0&id=46841fb6&lang=scss&scoped=true"
import "./Form.vue?vue&type=style&index=1&id=46841fb6&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46841fb6"]])

export default __exports__